<template>
  <AuthFormWrapper>
    <template v-if="passwordSet">
      <div class="text-center">
        <p>Your account has been activated. You can now use your email address and password to sign in.</p>

        <RouterLink
          class="mt-5 btn btn-solid btn-primary"
          :to="{ name: 'app_auth_login' }"
        >
          Sign in
        </RouterLink>
      </div>
    </template>

    <template v-else>
      <p class="text-center">
        Set a password to activate your account
      </p>

      <SetPasswordForm @password-set="passwordSet = true" />
    </template>
  </AuthFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { SetPasswordForm } from '@/components/forms';
import { AuthFormWrapper } from '@/components/wrappers';

import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const token = useRoute().query.token;
const error = ref(null);
const passwordSet = ref(false);

if (!token) {
  error.value = 'The link to set your password is either invalid or has expired.';
}
</script>
